import React from 'react';

import DropdownSelector from '../../../../../../../../surveys/components/SurveyBuilderPage/TargetAudience/components/ProfilingQuestions/components/DropdownSelector/DropdownSelector';

import styles from './SearchDropdown.module.css';

export default ({
  fetchOptions,
  placeholder,
  onSelectCompleted,
  value,
  search = true,
  hideNoValueOption,
  returnAdditionalFieldOnSelect
}) => (
  <div>
    <div className={styles.filterItemContainer}>
      <div className={styles.filterType}>
        <DropdownSelector
          value={value}
          onSelectCompleted={onSelectCompleted}
          fetchOptions={fetchOptions}
          placeholder={placeholder}
          search={search}
          filterDropdownStyle={styles.filterDropdownSelectorContainer}
          hideNoValueOption={hideNoValueOption}
          returnAdditionalFieldOnSelect={returnAdditionalFieldOnSelect}
        />
      </div>
    </div>
  </div>
);
